import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Directive, ElementRef, EventEmitter, Input, isStandalone, OnInit, Output } from '@angular/core';

@Directive({ selector: '[smrtsDebounce]', standalone: false })
export class DebounceDirective implements OnInit {
  @Input() delay = 2000;
  @Output() keyUpDebounce = new EventEmitter();

  constructor(
    private elementRef: ElementRef
  ) { }

  ngOnInit(): void {
    fromEvent(this.elementRef.nativeElement, 'keyup')
      .pipe(
        debounceTime(this.delay),
      )
      .subscribe(() => {
        this.keyUpDebounce.emit();
      });
  }
}
